import { pageSizes, paramsDefaults } from '../constants/uiParams';

export const getSkipValidated = (skip, take) => {
  const isValid = skip % take === 0;
  return isValid ? skip : paramsDefaults.Skip;
};

export const getTakeValidated = (take) => {
  const isValid = Object
    .values(pageSizes)
    .some(size => size === take);

  return isValid ? take : paramsDefaults.Take;
};
